import { Component, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Button, Timepicker, TimeValue } from '@ntv360/component-pantry';

export interface BusinessHourRow {
    day: string;
    openControl: FormControl<TimeValue | null>;
    closeControl: FormControl<TimeValue | null>;
    is24h: boolean;
    enabled: boolean;
}

const defaultOpen: TimeValue = { hours: 12, minutes: 0 };
const defaultClose: TimeValue = { hours: 12, minutes: 0 };

function makeRow(day: string): BusinessHourRow {
    return {
        day,
        openControl: new FormControl<TimeValue | null>(defaultOpen),
        closeControl: new FormControl<TimeValue | null>(defaultClose),
        is24h: false,
        enabled: true,
    };
}

@Component({
    selector: 'app-hours',
    imports: [Button, Timepicker, ReactiveFormsModule],
    templateUrl: './hours.component.html',
    styleUrl: './hours.component.scss',
})
export class HoursComponent {
    /** Business hours for each day of the week */
    public businessHours = signal<BusinessHourRow[]>([
        makeRow('MON'),
        makeRow('TUE'),
        makeRow('WED'),
        makeRow('THU'),
        makeRow('FRI'),
        makeRow('SAT'),
        makeRow('SUN'),
    ]);

    /** Toggle 24h mode for a specific day */
    public toggle24h(index: number): void {
        this.businessHours.update((rows) =>
            rows.map((row, i) => (i === index ? { ...row, is24h: !row.is24h } : row)),
        );
    }

    /** Toggle enabled state for a specific day */
    public toggleEnabled(index: number): void {
        this.businessHours.update((rows) =>
            rows.map((row, i) => (i === index ? { ...row, enabled: !row.enabled } : row)),
        );
    }

    /** Bulk edit handler */
    public onBulkEdit(): void {
        console.log('Bulk edit triggered');
    }
}
